import { useState, useCallback } from 'react';
import { RoutesStations, getRouteStationsById } from '../types/routesStations';

const useRoutesStations = () => {
  const [ routesStations, setRoutesStations ] = useState<RoutesStations>({});

  const getRouteStationsById: getRouteStationsById = useCallback((id) => (
    routesStations[id]
  ), [routesStations]);

  return { routesStations, setRoutesStations, getRouteStationsById };
};

export default useRoutesStations;
